export const SET_DEVICE = "SET_DEVICE"
export const SET_DEVICE_TYPE = "SET_DEVICE_TYPE"
export const SET_MACHINE_INFO = "SET_MACHINE_INFO"